/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Document_StatusInputs */

const en_error_crm_document_status = /** @type {(inputs: Error_Crm_Document_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This document can no longer be changed this way.`)
};

/**
* | output |
* | --- |
* | "This document can no longer be changed this way." |
*
* @param {Error_Crm_Document_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_document_status = /** @type {((inputs?: Error_Crm_Document_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Document_StatusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_document_status(inputs)
});